"use strict";

exports.__esModule = true;
var onNumberFieldChange = exports.onNumberFieldChange = function onNumberFieldChange(text, minValue, maxValue, defaultValue) {
  var invalidSymbolsRegex = /[^\d]+/;
  if (invalidSymbolsRegex.test(text)) {
    return defaultValue;
  }

  var number = parseInt(text);
  if (isNaN(number)) {
    number = 0;
  }

  if (number < 0 || number > 5) {
    return defaultValue;
  }
  return number;
};